import { Avatar, Skeleton } from '@mui/material';
import React, { useEffect, useState, useRef } from 'react';
import Link from 'next/link';
import axios from 'axios';
import { GCS_BUCKET_URI } from '@/exports';
import { getAuthHeaders } from '@/utils/authHeader';

const BrandSlider = () => {
	const [brands, setBrands] = useState([]);
	const [page, setPage] = useState(0);
	const [pagination, setPagination] = useState(null);
	const [loading, setLoading] = useState(false);
	const containerRef = useRef(null);
	const size = 10;

	const fetchBrands = async (pageNumber) => {
		if (loading) return;

		setLoading(true);
		try {
			const response = await axios.get(
				'https://api.tinytexts.co/api/brands/known',
				{
					params: { page: pageNumber, size },
					headers: await getAuthHeaders(),
				}
			);

			const { brands: fetchedBrands, pagination: fetchedPagination } =
				response.data;

			setBrands((prev) => [...prev, ...fetchedBrands]);
			setPagination(fetchedPagination || null);
		} catch (error) {
			console.error('Error fetching brands:', error);
		}
		setLoading(false);
	};

	useEffect(() => {
		fetchBrands(page);
	}, [page]);

	const handleScroll = () => {
		const container = containerRef.current;

		if (
			container &&
			container.scrollWidth - container.scrollLeft <=
				container.clientWidth + 50 &&
			!loading &&
			pagination?.nextPage !== undefined
		) {
			setPage((prevPage) => prevPage + 1);
		}
	};
	useEffect(() => {
		if (containerRef.current) {
			containerRef.current.scrollTo({ left: 100, behavior: 'smooth' });
		}
	}, []);

	return (
		<div className='mb-4 w-full flex flex-col'>
			<div className='mb-4 text-2xl font-medium'>Brands</div>

			<div
				className='flex flex-nowrap overflow-auto gap-8'
				ref={containerRef}
				onScroll={handleScroll}
			>
				{brands?.map((brand, i) => (
					<div
						className='w-3/4 sm:w-1/2 lg:w-1/4 flex-shrink-0 mb-3'
						key={i}
					>
						<Link
							href={`/brand/${brand?.brandId}`}
							style={{ all: 'unset' }}
						>
							<div className='bg-gray-100 rounded-[8px] cursor-pointer p-3 hover:bg-gray-200'>
								<div className='flex justify-center'>
									{brand?.iconObjectName ? (
										<Avatar
											alt={`${brand?.name} logo`}
											sx={{ width: 55, height: 55 }}
											src={`${GCS_BUCKET_URI}/brand-icons/${brand?.iconObjectName}`}
											imgProps={{ loading: 'lazy' }}
										/>
									) : (
										<Skeleton
											variant='circular'
											width={55}
											height={55}
										/>
									)}
								</div>
								<h3
									style={{
										whiteSpace: 'nowrap',
										textOverflow: 'ellipsis',
										overflow: 'hidden',
										fontSize: '16px',
									}}
									className='text-center mb-0 mt-2'
								>
									{brand?.name}
								</h3>
							</div>
						</Link>
					</div>
				))}
				{loading && (
					<div className='flex justify-center items-center h-20'>
						<div className='w-12 h-12 border-4 border-t-primary border-blue-700 rounded-full animate-spin'></div>
					</div>
				)}
			</div>
		</div>
	);
};

export default BrandSlider;
